import React from 'react';
import { motion } from 'framer-motion';
export function MockupShowcase() {
  const mockups = [{
    src: 'https://cdn.magicpatterns.com/uploads/iVNHymL998bPi2mWzGxJB1/mk1.png',
    alt: 'Ebook Infancia Analógica',
    title: 'El Método Principal',
    delay: 0.1
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ttdj1bh2bamNXKNgN6MHgG/bn1.png',
    alt: 'Kit Cena Fuera Sin iPad',
    title: 'Bono 1: Cenas Sin Pantallas',
    delay: 0.2
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/hecVG7BZQMjksBUEELd8X5/bn2.png',
    alt: '50 Invitaciones al Juego Solo',
    title: 'Bono 2: 50 Juegos Solo',
    delay: 0.3
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jFBwDdRfryyscBK4e5vh8B/bn3.png',
    alt: 'Guía Mi Primer Celular',
    title: 'Bono 3: Mi Primer Celular',
    delay: 0.4
  }];
  return <div className="w-full max-w-5xl mx-auto mt-8 pb-6 px-4" data-id="element-114">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-6" data-id="element-115">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-cream mb-2" data-id="element-116">
          Todo lo que incluye tu acceso hoy
        </h2>
        <div className="w-16 h-1 bg-terracotta mx-auto rounded-full" data-id="element-117"></div>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-118">
        {mockups.map((mockup, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: mockup.delay
      }} className="bg-white/5 p-4 rounded-2xl border border-white/10 backdrop-blur-sm group hover:bg-white/10 transition-colors" data-id="element-119">
            <div className="overflow-hidden rounded-xl mb-4" data-id="element-120">
              <img src={mockup.src} alt={mockup.alt} className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-121" />
            </div>
            <h3 className="text-xl font-bold text-cream text-center" data-id="element-122">
              {mockup.title}
            </h3>
          </motion.div>)}
      </div>
    </div>;
}